/**
 * Asynchronously loads the component for legacy project page
 */

import React from 'react'
import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "LegacyProjectRoute" */ './index'), {
  fallback: <LoadingPage />
})
